import CategoriesApi from '@/services/shop/CategoriesApiV2'

export interface CategoryInterface {
  id: string
  name: string
  code: string
  l10n_name_key: string
  sort_order: number
  managed_by_roles: string[]
  created_at: string
  updated_at: string
}

export class CategoryDTO implements CategoryInterface {
  id = ''
  name = ''
  code = ''
  l10n_name_key = ''
  sort_order = 0
  managed_by_roles: string[] = []
  created_at = ''
  updated_at = ''
}

export default class Category extends CategoryDTO {
  static api = CategoriesApi

  constructor(DTO: CategoryDTO) {
    super()
    Object.assign(this, DTO)
  }
}
